import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import DatiQuestionarioSanitario from './sezione/DatiQuestionarioSanitario';

const styles = theme => ({
  root: {
    width: '100%',
  },
});
			
function QuestionarioSanitarioPanel(props) {
	
  const { classes, isValida } = props;
  return (
    <div className={classes.root}> 
      <ExpansionPanelComp titolo={'questionarioSanitario'} componente={DatiQuestionarioSanitario} isValida={isValida} /> 
    </div>
  );
}

QuestionarioSanitarioPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(QuestionarioSanitarioPanel);
